import script from "./BaseHealthCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseHealthCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseHealthCard.vue?vue&type=style&index=0&id=534a9f9f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-534a9f9f"]])

export default __exports__